var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutomate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7897_29845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14.1123V16.6123",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 34.1123V31.6123",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.974 20.1123C28.844 18.1603 27.234 16.6123 25.25 16.6123H22.51C20.57 16.6123 19 18.1843 19 20.1223C19 21.7323 20.096 23.1363 21.656 23.5283L26.342 24.7043C27.904 25.0963 28.998 26.5003 28.998 28.1103C28.998 30.0503 27.426 31.6203 25.488 31.6203H22.748C20.76 31.6203 19.15 30.0683 19.022 28.1123",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2402 11.8563C15.3782 8.71832 19.7142 6.77832 24.5042 6.77832C34.0822 6.77832 41.8482 14.5403 41.8482 24.1143C41.8482 25.4503 41.6822 26.7463 41.3962 27.9963",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7129 25.3164L41.8469 28.4504L44.9809 25.3164",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7603 36.3685C33.6223 39.5065 29.2863 41.4465 24.4963 41.4465C14.9183 41.4465 7.15234 33.6845 7.15234 24.1105C7.15234 22.7745 7.31834 21.4785 7.60434 20.2285",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2856 22.9084L7.15158 19.7744L4.01758 22.9084",
    stroke: "#8594AC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7897_29845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.112305)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomate);
export default __webpack_public_path__ + "static/media/Automate.cddb5d35ebe6ba80068e74e1179b48fe.svg";
export { ForwardRef as ReactComponent };